import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailButtonComponent } from '../../components/email-button/email-button.component';
import { EmailLayoutComponent } from '../../components/email-layout/email-layout.component';
import { EmailLinkComponent } from '../../components/email-link/email-link.component';
import { EmailMarginComponent } from '../../components/email-margin/email-margin.component';
import { EmailMessageHeaderComponent } from '../../components/email-message-header/email-message-header.component';
import { EmailRecruiteeLogoComponent } from '../../components/email-recruitee-logo/email-recruitee-logo.component';
import { EmailTextComponent } from '../../components/email-text/email-text.component';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import { WrappedValue } from '../../mailgun/wrap-value';

@Component({
  standalone: true,
  selector: 'email-admin-deleted-template',
  styleUrls: ['../../global-styles.less'],
  templateUrl: './admin-deleted.component.html',
  imports: [
    EmailMarginComponent,
    EmailLayoutComponent,
    EmailRecruiteeLogoComponent,
    EmailMessageHeaderComponent,
    EmailTextComponent,
    EmailButtonComponent,
    EmailLinkComponent,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  encapsulation: ViewEncapsulation.None,
})
export class AdminDeletedTemplateComponent {
  @Input({ required: true }) public data: WrappedValue<AdminDeletedTemplateData>;
}

export type AdminDeletedTemplateData = {
  title: string;
  p1_html: string;
  footer: {
    text: string;
    label: string;
    href: string;
    target: string;
  };
};

export const AdminDeletedTemplateMocks: AdminDeletedTemplateData[] = [
  {
    title: 'Hi Jane 👋',
    p1_html: 'Your account and all user data have been <b>permanently deleted</b>.',
    footer: {
      text: 'Need help?',
      label: 'Contact us',
      href: 'https://auth.recruitee.com/?intercom_open=true',
      target: '_blank',
    },
  },
];
